<template>
    <q-icon
            name="fa fa-star"
            :color="color"
            :title="title"
            :class="{'fa-spin': isLoading}"
            v-bind="$attrs"
            @click.stop.prevent="toggle"
    />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import { HasTaskMixin } from '@/mixins';
import { UserClient } from '@/type';
import { star, unstar } from './user-client';

export default defineComponent({
  mixins: [HasTaskMixin],
  props: {
    userClient: {
      type: Object as () => UserClient,
    },
  },
  computed: {
    isStarred(): boolean {
      return !_.isNull(this.userClient.starredAt);
    },
    color(): string {
      return this.isStarred ? 'positive' : 'grey-5';
    },
    title(): string {
      return this.isStarred ? 'Unstar Client' : 'Star Client';
    },
  },
  methods: {
    toggle() {
      if (this.isStarred) {
        this.unstar();
      } else {
        this.star();
      }
    },
    star() {
      this.task = star(this.userClient.user.id, this.userClient.client.id);
    },
    unstar() {
      this.task = unstar(this.userClient.user.id, this.userClient.client.id);
    },
  },
});
</script>
